import React from "react";
import styles from "./ContactsPage.module.scss";

function ContactsPage() {
  return (
    <div className={styles.contactsPage}>
      <h1 className={styles.title}>Контакты и реквизиты</h1>

      <div className={styles.content}>
        {/* Левая колонка — контакты + реквизиты */}
        <section className={styles.detailsCard}>
          <h2 className={styles.sectionTitle}>Контакты</h2>

          <dl className={styles.requisitesList}>
            <div className={styles.row}>
              <dt>Телефон</dt>
              <dd>
                <a href="tel:+79217637808" className={styles.link}>
                  +7 921 763‑78‑08
                </a>
              </dd>
            </div>

            <div className={styles.row}>
              <dt>Адрес</dt>
              <dd>
                Санкт-Петербург, ТЦ&nbsp;«Долгоозерный»
                <br />
                ул.&nbsp;Ильюшина, д.&nbsp;14, помещение&nbsp;346
              </dd>
            </div>

            <div className={styles.row}>
              <dt>ВКонтакте</dt>
              <dd>
                <a
                  href="https://vk.ru/dekormoegodoma"
                  target="_blank"
                  rel="noopener noreferrer"
                  className={styles.link}
                >
                  vk.ru/dekormoegodoma
                </a>
              </dd>
            </div>
          </dl>

          <h2 className={styles.sectionTitle} style={{ marginTop: 28 }}>
            Реквизиты счета
          </h2>

          <dl className={styles.requisitesList}>
            <div className={styles.row}>
              <dt>Название организации</dt>
              <dd>ИНДИВИДУАЛЬНЫЙ ПРЕДПРИНИМАТЕЛЬ РОДИОНОВА ЕЛЕНА ЛЕОНИДОВНА</dd>
            </div>

            <div className={styles.row}>
              <dt>Юридический адрес организации</dt>
              <dd>
                197373, РОССИЯ, Г САНКТ-ПЕТЕРБУРГ, УЛ ГЛУХАРСКАЯ, Д 11, КОРП 1,
                КВ 25
              </dd>
            </div>

            <div className={styles.row}>
              <dt>ИНН</dt>
              <dd>780203140758</dd>
            </div>

            <div className={styles.row}>
              <dt>ОГРНИП</dt>
              <dd>314784736701622</dd>
            </div>

            <div className={styles.row}>
              <dt>Расчетный счет</dt>
              <dd>40802810800002088618</dd>
            </div>

            <div className={styles.row}>
              <dt>Банк</dt>
              <dd>АО «ТБанк»</dd>
            </div>

            <div className={styles.row}>
              <dt>ИНН банка</dt>
              <dd>7710140679</dd>
            </div>

            <div className={styles.row}>
              <dt>БИК банка</dt>
              <dd>044525974</dd>
            </div>

            <div className={styles.row}>
              <dt>Корреспондентский счет банка</dt>
              <dd>30101810145250000974</dd>
            </div>

            <div className={styles.row}>
              <dt>Юридический адрес банка</dt>
              <dd>127287, г. Москва, ул. Хуторская 2-я, д. 38А, стр. 26</dd>
            </div>
          </dl>

        </section>

        {/* Правая колонка — карта */}
        <section className={styles.mapCard}>
          <h2 className={styles.sectionTitle}>Мы на карте</h2>

          <div className={styles.mapWrapper}>
            <iframe
              title="Адрес магазина"
              src="https://yandex.ru/map-widget/v1/?text=%D0%A1%D0%B0%D0%BD%D0%BA%D1%82-%D0%9F%D0%B5%D1%82%D0%B5%D1%80%D0%B1%D1%83%D1%80%D0%B3%2C%20%D1%83%D0%BB.%20%D0%98%D0%BB%D1%8C%D1%8E%D1%88%D0%B8%D0%BD%D0%B0%2C%20%D0%B4.%2014&z=16"
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              className={styles.mapIframe}
            ></iframe>
          </div>

          <p className={styles.mapHint}>
            Если карта не отобразилась <code>возможно</code> у вас включен VPN.
          </p>
        </section>
      </div>
    </div>
  );
}

export default ContactsPage;